var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPerson = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#DBDBDB",
  strokeLinecap: "round",
  strokeWidth: 1.25,
  d: "M12 13.5a7.5 7.5 0 0 0-7.237 5.523C4.473 20.089 5.395 21 6.5 21h11c1.104 0 2.027-.911 1.736-1.977A7.5 7.5 0 0 0 12 13.5ZM15.5 7a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
})));
export default SvgPerson;